import { createEnv } from "@t3-oss/env-nextjs"
import { z } from "zod/v4"
import { getUrl } from "./utils"

export const env = createEnv({
  client: {
    NEXT_PUBLIC_BASE_URL: z.preprocess((url) => getUrl(false, url as string), z.string()),
    NEXT_PUBLIC_DEVELOPMENT_MODE: z.stringbool().default(false),
    NEXT_PUBLIC_PREVIEW_MODE: z.stringbool().default(false),
    NEXT_PUBLIC_PRODUCTION_MODE: z.stringbool().default(false),
    NEXT_PUBLIC_SHOW_HIDDEN_PAGES: z.stringbool().default(false),
    NEXT_PUBLIC_POSTHOG_HOST: z.url(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_CLOUDFLARE_R2_BUCKET_URL: z.url(),
    NEXT_PUBLIC_NOVU_APPLICATION_IDENTIFIER: z.string(),
  },
  runtimeEnv: {
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_DEVELOPMENT_MODE: process.env.NEXT_PUBLIC_DEVELOPMENT_MODE,
    NEXT_PUBLIC_PREVIEW_MODE: process.env.NEXT_PUBLIC_PREVIEW_MODE,
    NEXT_PUBLIC_PRODUCTION_MODE: process.env.NEXT_PUBLIC_PRODUCTION_MODE,
    NEXT_PUBLIC_SHOW_HIDDEN_PAGES: process.env.NEXT_PUBLIC_SHOW_HIDDEN_PAGES,
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_CLOUDFLARE_R2_BUCKET_URL: process.env.NEXT_PUBLIC_CLOUDFLARE_R2_BUCKET_URL,
    NEXT_PUBLIC_NOVU_APPLICATION_IDENTIFIER: process.env.NEXT_PUBLIC_NOVU_APPLICATION_IDENTIFIER,
  },
  emptyStringAsUndefined: true,
})
